import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { CreateShipmentFormDataKey, PalletRecord } from "src/types";
import { validateShipmentPalletComposition } from "src/helpers";

export class CreateShipmentFormValidator extends FormValidator {
  private static validateSelectedPallets(value: unknown): ValidationError<CreateShipmentFormDataKey> | undefined {
    const pallets = value as PalletRecord[];
    if (!pallets || pallets.length === 0) {
      return new ValidationError("At least one pallet must be assigned to the shipment", "selectedPallets");
    }
    const compositionError = validateShipmentPalletComposition(pallets);
    if (compositionError) {
      return new ValidationError(compositionError, "selectedPallets");
    }
    return undefined;
  }

  private static readonly validationStrategies: Record<
    CreateShipmentFormDataKey,
    (value: unknown) => ValidationError<CreateShipmentFormDataKey> | undefined
  > = {
    selectedPallets: CreateShipmentFormValidator.validateSelectedPallets,
    goodsDescription: () => undefined
  };

  static validateCreateShipmentFormData<T extends CreateShipmentFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(formData, CreateShipmentFormValidator.validationStrategies as never);
  }
}
